import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faArrowDownAZ,
  faEdit,
  faEye,
  faFile,
  faPlus,
  faSearch,
  faShieldAlt,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import {
  collegeListing,
  collegeStatus,
  deleteIndCollege,
} from "../../../../services/college";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Rating, Typography } from "@mui/material";
import Loader from "../../../../HOC/Loader";
// import NoData from "../../../../components/common/NoData";
import ReactPaginate from "react-paginate";
import usePermissionStatus from "../../../../hooks/usePermissionStatus";
import { toast } from "react-hot-toast";
import moment from "moment";
import { generateConfirm } from "../../../../helpers";
import useScrollTop from "../../../../hooks/useScrollTop";
import IndianCollegeFilter from "../../../subadmin/taskassign/assignmodel/IndianCollegeFilter";
import { useSelector } from "react-redux";
import {
  myTaskList,
  removeAccess,
  taskList,
} from "../../../../services/subadmin";
import CollegeTabs from "../collegeRequests/CollegeTabs";

const Filter = process.env.PUBLIC_URL + "/assets/images/filter.svg";
const Filter2 = process.env.PUBLIC_URL + "/assets/images/filter2.svg";
const Filter3 = process.env.PUBLIC_URL + "/assets/images/filter3.svg";

const tabName = ["task", "college"];
const Colleges = () => {
  const location = useLocation();
  const [collegeLists, setCollegeLists] = useState([]);
  const [limitPage, setLimitPage] = useState(10);
  const [limitPageTask, setLimitPageTask] = useState(10);
  const permit = usePermissionStatus("Colleges");
  const [pageCount, setPageCount] = useState(0);
  const [pageCountTask, setPageCountTask] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [totalCountTask, setTotalCountTask] = useState(0);
  const [searchCollege, setSearchCollege] = useState("");
  const [searchTask, setSearchTask] = useState("");
  const [skip, setSkip] = useState(1);
  const [skipTask, setSkipTask] = useState(1);
  const [filterModalShow, setFilterModalShow] = useState(false);
  const assignColegeFilter = useSelector(
    (state) => state.assignedCollegeFilter
  );
  const [filterData, setFilterData] = useState({ city: "", state: "" });
  const role = localStorage.getItem("role") || "";
  const [tab, setTab] = useState(
    location?.state?.tab ? location?.state?.tab : 0
  );
  const [listTask, setListTask] = useState([]);
  const [removeKey, setRemoveKey] = useState("");
  const [isLoading, setLoading] = useState(false);

  console.log("redux data", assignColegeFilter);
  let navigate = useNavigate();
  useScrollTop();

  let payload = {
    search_key: searchCollege,
    limit: limitPage,
    modules: "",
    city: filterData?.city ? filterData?.city : "",
    state: filterData?.state ? filterData?.state : "",
  };

  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setSkip(selectedPage + 1);
  };

  useEffect(() => {
    getCollegeList();
  }, [skip, limitPage, searchCollege, filterData?.city, filterData?.state]);

  const getCollegeList = async () => {
    setLoading(true);

    let json = await collegeListing({ ...payload, page: Number(skip) });
    setCollegeLists(json?.data?.result || []);
    setPageCount(Math.ceil(json?.data?.total_count / payload.limit || 0));
    setTotalCount(json?.data?.total_count);
    setLoading(false);
    // setSkip(payload.skip)
  };
  const delCollegeList = async (id) => {
    await deleteIndCollege({ college_id: id }).then(() => {
      getCollegeList();
    });
  };

  const setClick = (collegeId) => {
    if (collegeId) {
      navigate("/indian-colleges-details/" + collegeId);
    }
  };

  const type = localStorage.getItem("admin_type") || "";

  const handleActive = async (college_id, type, status) => {
    let payload = {
      college_id,
      type,
      status,
    };
    let response = await collegeStatus(payload);
    if (response?.data?.statusCode === 200) {
      toast.dismiss();
      toast.success(response?.data?.statusMessage || "Success");
      getCollegeList();
    } else {
      toast.dismiss();
      toast.error(response?.data?.statusMessage || "Success");
    }
  };

  const handleLimitPage = (e) => {
    const newLimit = e.target.value;
    setLimitPage(newLimit);
    let updatedPayload = {
      ...payload,
      limit: newLimit,
    };
    getCollegeList(updatedPayload);
  };

  // tasks

  const handlePageClickTask = (e) => {
    const selectedPage = e.selected;
    setSkipTask(selectedPage + 1);
  };

  let payload1 = {
    // task_status: "pending",
    limit: limitPageTask,
    // search_key: searchTask,
  };
  const getTaskList = async () => {
    let response = await myTaskList({ ...payload1, page: Number(skipTask) });
    if (response?.data?.statusCode === 200) {
      setListTask(response?.data?.result || []);
      setPageCountTask(
        Math.ceil(response?.data?.total_count / payload1.limit || 0)
      );
      setTotalCountTask(response?.data?.total_count);
    }
  };

  const handleLimitPageTask = (e) => {
    const newLimit = e.target.value;
    setLimitPageTask(newLimit);
    let updatedPayload = {
      ...payload,
      limit: newLimit,
    };
    getTaskList(updatedPayload);
  };

  const getRemoveAccess = async (collegeid) => {
    await removeAccess({ college_id: JSON.stringify(collegeid) });
    getCollegeList();
  };
  return (
    <>
      {type === "admin" ? (
        <div className="dashboard college-list">
          <div className="subheader">
            <Row>
              <Col xs={5}>
                {/* <div className="subheader-title">
                  <h2 className="heading-36">Indian Colleges</h2>
                </div> */}
              </Col>
              <Col xs={7}>
                <div className={`subheader-right `}>
                  <div className="subheader-right-top">
                    <Form.Group
                      controlId="formFile"
                      className="subheader-search"
                    >
                      <Form.Control
                        type="search"
                        placeholder="search here"
                        onChange={(e) => {
                          setSearchCollege(e.target.value);
                        }}
                        value={searchCollege}
                      />
                      <FontAwesomeIcon
                        icon={faSearch}
                        className="search-icon"
                      />
                    </Form.Group>
                    <button
                      onClick={() => navigate("/addcollege")}
                      className={`${permit ? "" : "disabledbutton"} add-btn`}
                    >
                      <FontAwesomeIcon icon={faPlus} />
                      Add New College
                    </button>
                  </div>
                  <div className="subheader-right-btm">
                    <Button
                      className={`btn-purple ${permit ? "" : "disabledbutton"}`}
                      onClick={() => {
                        setFilterModalShow(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faArrowDownAZ} />
                      Filter
                    </Button>
                    <Button
                      className={`btn-purple ${permit ? "" : "disabledbutton"}`}
                      onClick={() => navigate(`/edit-request`)}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                      Edit Requests
                    </Button>
                    <Button
                      className={`btn-purple ${permit ? "" : "disabledbutton"}`}
                    >
                      <FontAwesomeIcon icon={faFile} />
                      Export
                    </Button>
                    <Button
                      className={`btn-purple ${permit ? "" : "disabledbutton"}`}
                    >
                      <FontAwesomeIcon icon={faShieldAlt} />
                      Verify Selected
                    </Button>
                    <Button
                      className={`btn-purple ${permit ? "" : "disabledbutton"}`}
                    >
                      <FontAwesomeIcon icon={faArrowDownAZ} />
                      Sort
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <div className=" table-main fixTableHead">
            {!isLoading && (
              <table className="table nowrap table-bordered table-default-dark ">
                <thead>
                  <tr className="table-heading">
                    {/* <th>
                      <Form>
                        {["checkbox"].map((type) => (
                          <div key={`default-${type}`} className=" facility-check">
                            <ul className="m-0">
                              <li>
                                <Form.Check type={type} id={`default-${type}`} />
                              </li>
                            </ul>
                          </div>
                        ))}
                      </Form>
                    </th> */}
                    <th className="td_ellipse">College ID</th>
                    <th className="td_ellipse">College Name</th>
                    <th className="td_ellipse">City</th>
                    <th className="td_ellipse">Rating</th>
                    <th className="td_ellipse">Verification</th>
                    <th className="td_ellipse">CAP</th>
                    {/* <th className="td_ellipse">Level</th> */}
                    <th className="td_ellipse">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {/* {!isLoading && !!collegeLists.length === 0 && <h1 className="no-data">No Data Found</h1>} */}
                  {collegeLists?.map((list) => (
                    <tr key={list.id}>
                      {/* <td>
                        <Form>
                          {["checkbox"].map((type) => (
                            <div key={`default-${type}`} className="facility-check">
                              <ul className="m-0">
                                <li>
                                  <Form.Check className={`${permit ? "" : "disabledbutton"}`} type={type} id={`default-${type}`} />
                                </li>
                              </ul>
                            </div>
                          ))}
                        </Form>
                      </td> */}
                      <td className="td_ellipse">{list.clg_id}</td>
                      <td
                        className="td_ellipse"
                        onClick={() => {
                          setClick(list.id);
                        }}
                      >
                        {list.clg_name}
                      </td>
                      <td
                        className="td_ellipse"
                        onClick={() => {
                          setClick(list.id);
                        }}
                      >
                        {list.clg_city}
                      </td>
                      <td
                        onClick={() => {
                          setClick(list.id);
                        }}
                      >
                        <div className="rating-start">
                          <Rating
                            name="customized-10"
                            defaultValue={3}
                            max={5}
                          />
                        </div>
                      </td>
                      <td className="td_ellipse ">
                        <Form.Select
                          value={list.verification_status}
                          className="form-control"
                          aria-label="Default select example"
                          onChange={(e) => {
                            handleActive(
                              list.id,
                              "verification_status",
                              e.target.value
                            );
                          }}
                        >
                          <option>Select Options</option>
                          <option value="non_verified">Non Verified</option>
                          <option value="verified">Verified</option>
                          <option value="in_progress">In Progress</option>
                          <option value="hold">Hold</option>
                          <option value="rejected">Rejected</option>
                          <option value="re_applied">Re-Applied</option>
                        </Form.Select>
                      </td>
                      {/* <td className="td_ellipse ">
                        <Form.Select
                          value={list.cap}
                          className="form-control"
                          aria-label="Default select example"
                          onChange={(e) => {
                            handleActive(list.id, "cap", e.target.value);
                          }}
                        >
                          <option>Select Options</option>
                          <option value="applicable">Applicable</option>
                          <option value="not_applicable">Not Applicable</option>
                          <option value="in_progress">In Progress</option>
                        </Form.Select>
                      </td> */}
                      <td>{list?.education_level || "NA"}</td>
                      <td className={`${permit ? "" : "disabledbutton"}`}>
                        <div className="action_btn">
                          <Button
                            type="button"
                            onClick={() =>
                              navigate(`/edit-college/${list?.id}`)
                            }
                            className="edit-btn me-1"
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </Button>
                          {/* <Button type="button" className="delete-btn">
                            <FontAwesomeIcon icon={faEdit} />
                          </Button> */}
                          <Button type="button" className="delete-btn ml-1">
                            <FontAwesomeIcon
                              onClick={() => {
                                generateConfirm(
                                  "Are you sure you want to Delete College ?",
                                  "Press Yes if you want to delete",
                                  "clg-delete",
                                  () => {
                                    delCollegeList(list.id);
                                  }
                                );
                              }}
                              icon={faTrash}
                            />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            {!!isLoading && <h1 className="no-data">Loading...</h1>}

            {!isLoading && collegeLists?.length === 0 && (
              <h1 className="no-data">No Record Found</h1>
            )}
          </div>
          {totalCount > payload.limit && (
            <div>
              <ReactPaginate
                previousLabel={<FontAwesomeIcon icon={faAngleDoubleLeft} />}
                nextLabel={<FontAwesomeIcon icon={faAngleDoubleRight} />}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination custom-pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          )}
        </div>
      ) : role === "content_manager" ? (
        <div className="wrapper-assignpage">
          <div className="middle-header">
            <div className="subadmin-search assigned-college">
              <div className="subheader-title ">
                <h2 className="heading-36 me-5">Assigned Colleges</h2>
              </div>
              <div className="tabs-button">
                {/* <button className="preference">
                    <img src={Filter} /> Preference
                  </button> */}
                <button className=" ms-5 preference filter2">
                  <img src={Filter2} /> Export as csv
                </button>
                <button
                  className="preference filter3"
                  onClick={() => {
                    setFilterModalShow(true);
                  }}
                >
                  <img src={Filter3} /> Filters
                </button>
                <div>
                  <div className="subheader-search subadmin-search">
                    <input
                      placeholder="search here"
                      type="search"
                      id="formFile"
                      onChange={(e) => {
                        setSearchCollege(e.target.value);
                      }}
                      value={searchCollege}
                      className="form-control text-color-black"
                    />
                    <FontAwesomeIcon icon={faSearch} className="search-icon" />
                  </div>
                </div>
              </div>
              <div className="itemselected-bx d-flex">
                <Form.Select
                  className="form-control select-selected"
                  onChange={(e) => handleLimitPage(e)}
                >
                  <option>Row No.</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </Form.Select>
              </div>
            </div>
          </div>
          <div className=" table-main fixTableHead">
            <table className="table subadmin-table nowrap table-bordered table-default-dark subadmin-table">
              <thead>
                <tr className="subadmin-table-heading">
                  <th className="td_ellipse text-center">S. No.</th>
                  <th className="td_ellipse text-center">College ID</th>
                  <th className="td_ellipse text-center">College Name</th>
                  <th className="td_ellipse text-center">City</th>
                  <th className="td_ellipse text-center">State</th>
                  <th className="td_ellipse text-center"> Remove Access</th>
                  {/* <th className='td_ellipse text-center'>Created At</th> */}
                  {/* <th className='td_ellipse text-center'>Modified Date</th> */}
                </tr>
              </thead>
              <tbody>
                {collegeLists?.map((list, index) => (
                  <tr className="table-shadow" key={list.id}>
                    <td
                      className="td_ellipse"
                      onClick={() => {
                        setClick(list.id);
                      }}
                    >
                      {index + 1 || "NA"}
                    </td>
                    <td
                      className="td_ellipse"
                      onClick={() => {
                        setClick(list.id);
                      }}
                    >
                      {list.clg_id || "NA"}
                    </td>
                    <td
                      className="td_ellipse"
                      onClick={() => {
                        setClick(list.id);
                      }}
                    >
                      {list.clg_name || "NA"}
                    </td>
                    <td className="td_ellipse">{list.clg_city}</td>
                    <td className="td_ellipse">{list.state}</td>
                    <td className="td_ellipse">
                      <button
                        type="button"
                        onClick={() => {
                          generateConfirm(
                            "Are you sure you want to Remove Access ?",
                            "Press Yes if you want to remove",
                            "clg-delete",
                            () => {
                              getRemoveAccess(list.id);
                            }
                          );
                        }}
                        className="btn btn-danger"
                      >
                        Remove Access
                      </button>
                    </td>
                    {/* <td className='td_ellipse'>{moment(list.created_at).format("DD/MM/YYYY") || "N/A"}</td>
                      <td className='td_ellipse'>{moment(list.updated_on).format("DD/MM/YYYY") || "N/A"}</td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {totalCount > payload.limit && (
            <div>
              <ReactPaginate
                previousLabel={<FontAwesomeIcon icon={faAngleDoubleLeft} />}
                nextLabel={<FontAwesomeIcon icon={faAngleDoubleRight} />}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination custom-pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          )}
        </div>
      ) : (
        <div>
          <div className="subadmin-nav-tab">
            <div
              className={`tabbing-button ${tab === 0 ? "active" : ""}`}
              onClick={() => setTab(0)}
            >
              <button>Colleges</button>
            </div>
            <div
              className={`tabbing-button ${tab === 1 ? "active" : ""}`}
              onClick={() => {
                setTab(1);
                getTaskList();
              }}
            >
              <button>Tasks</button>
            </div>
          </div>
          {tab === 0 && (
            <div className="wrapper-assignpage">
              <div className="middle-header">
                <div className="subadmin-search assigned-college">
                  <div className="subheader-title ">
                    <h2 className="heading-36 me-5">Assigned Colleges</h2>
                  </div>
                  <div className="tabs-button">
                    {/* <button className="preference">
                    <img src={Filter} /> Preference
                  </button> */}
                    <button className=" ms-5 preference filter2">
                      <img src={Filter2} /> Export as csv
                    </button>
                    <button
                      className="preference filter3"
                      onClick={() => {
                        setFilterModalShow(true);
                      }}
                    >
                      <img src={Filter3} /> Filters
                    </button>
                    <div>
                      <div className="subheader-search subadmin-search">
                        <input
                          placeholder="search here"
                          type="search"
                          id="formFile"
                          onChange={(e) => {
                            setSearchCollege(e.target.value);
                          }}
                          value={searchCollege}
                          className="form-control text-color-black"
                        />
                        <FontAwesomeIcon
                          icon={faSearch}
                          className="search-icon"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="itemselected-bx d-flex">
                    <Form.Select
                      className="form-control select-selected"
                      onChange={(e) => handleLimitPage(e)}
                    >
                      <option>Row No.</option>
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </Form.Select>
                  </div>
                </div>
              </div>
              <div className=" table-main fixTableHead">
                <table className="table subadmin-table nowrap table-bordered table-default-dark subadmin-table">
                  <thead>
                    <tr className="subadmin-table-heading">
                      <th className="td_ellipse text-center">S. No.</th>
                      <th className="td_ellipse text-center">College ID</th>
                      <th className="td_ellipse text-center">College Name</th>
                      <th className="td_ellipse text-center">City</th>
                      <th className="td_ellipse text-center">State</th>

                      {/* <th className='td_ellipse text-center'>Created At</th>
                    <th className='td_ellipse text-center'>Modified Date</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {collegeLists?.map((list, index) => (
                      <tr className="table-shadow" key={list.id}>
                        <td
                          className="td_ellipse"
                          onClick={() => {
                            setClick(list.id);
                          }}
                        >
                          {index + 1 || "NA"}
                        </td>
                        <td
                          className="td_ellipse"
                          onClick={() => {
                            setClick(list.id);
                          }}
                        >
                          {list.clg_id || "NA"}
                        </td>
                        <td
                          className="td_ellipse"
                          onClick={() => {
                            setClick(list.id);
                          }}
                        >
                          {list.clg_name || "NA"}
                        </td>
                        <td className="td_ellipse ">{list.clg_city}</td>
                        <td className="td_ellipse ">{list.state}</td>
                        {/* <td className='td_ellipse'>{moment(list.created_at).format("DD/MM/YYYY") || "N/A"}</td>
                      <td className='td_ellipse'>{moment(list.updated_on).format("DD/MM/YYYY") || "N/A"}</td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {totalCount > payload.limit && (
                <div>
                  <ReactPaginate
                    previousLabel={<FontAwesomeIcon icon={faAngleDoubleLeft} />}
                    nextLabel={<FontAwesomeIcon icon={faAngleDoubleRight} />}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination custom-pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                  />
                </div>
              )}
            </div>
          )}
          {tab === 1 && (
            <div className="wrapper-assignpage">
              <div className="dashboard">
                <div className="subheader wrapassign-subheader">
                  <div className="subheader-title">
                    <h2 className="heading-36"> Assign Task</h2>
                  </div>
                  <div className="subheader-right-top ">
                    <div className="subheader-search subadmin-search">
                      <input
                        placeholder="search here"
                        type="search"
                        id="formFile"
                        className="form-control"
                        onChange={(e) => {
                          setSearchTask(e.target.value);
                        }}
                        value={searchTask}
                      />
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="magnifying-glass"
                        className="svg-inline--fa fa-magnifying-glass search-icon"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          fill="currentColor"
                          d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z"
                        ></path>
                      </svg>
                    </div>
                    <button className="me-2 preference filter2">
                      <img className="me-1" src="/assets/images/filter2.svg" />
                      Export as csv
                    </button>
                  </div>
                  <div className="itemselected-bx d-flex">
                    <Form.Select
                      className="form-control select-selected"
                      onChange={(e) => handleLimitPageTask(e)}
                    >
                      <option>Row No.</option>
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </Form.Select>
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <div className=" table-main fixTableHead">
                    <table className="table nowrap table-bordered table-default-dark subadmin-table">
                      <thead>
                        <tr className="subadmin-table-heading">
                          <th className="td_ellipse">Task Id</th>
                          <th className="td_ellipse">Task Title</th>
                          <th className="td_ellipse">Assigned By </th>
                          <th className="td_ellipse">Role</th>
                          <th className="td_ellipse">Assign Date</th>
                          <th className="td_ellipse">Deadline Date</th>
                          <th className="td_ellipse">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listTask.map((item, index) => (
                          <tr key={index}>
                            <td className="td_ellipse">
                              {item?.task_id || "N/A"}
                            </td>
                            <td className="td_ellipse">
                              {item?.task_title || "N/A"}
                            </td>
                            <td className="td_ellipse">
                              {item?.assigned_by || "N/A"}
                            </td>
                            <td className="td_ellipse">
                              {item?.role === "content_manager"
                                ? "Content Manager"
                                : role === "content_manager"
                                ? "Team Lead"
                                : "Intern" || "N/A"}
                            </td>
                            <td className="td_ellipse">
                              {moment(item.assigned_on).format("DD/MM/YYYY") ||
                                "N/A"}
                            </td>
                            <td className="td_ellipse">
                              {moment(item.deadline_date).format(
                                "DD/MM/YYYY"
                              ) || "N/A"}
                            </td>
                            <td className="action_btn justify-content-center wrap-action-btn">
                              <button
                                type="button"
                                className="eye-btn  btn-primary"
                                onClick={() =>
                                  navigate(
                                    `/task-detail/${item.task_id}?category=mytask`
                                  )
                                }
                              >
                                <FontAwesomeIcon
                                  className="eye-icon"
                                  icon={faEye}
                                />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="paginatipn">
                  {totalCountTask > payload1.limit && (
                    <div>
                      <ReactPaginate
                        previousLabel={"Previous"}
                        nextLabel={"Next"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCountTask}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClickTask}
                        containerClassName={"pagination custom-pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      <IndianCollegeFilter
        show={filterModalShow}
        onHide={() => setFilterModalShow(false)}
        mainList={() => getCollegeList()}
        setFilterData={setFilterData}
      />
    </>
  );
};

export default Colleges;
